module.exports = __webpack_public_path__ + "static/media/fiscal-s.d1a7cae6.jpg";